const SCRIPT_BLOCK_RE = /<script\b[^>]*>[\s\S]*?<\/script>/gi;
const SCRIPT_OPEN_RE = /<script\b[^>]*>/gi;

/** DOMParser 가 script 태그에서 파싱을 중단하지 않도록 플레이스홀더로 치환 */
function protectScriptBlocks(html: string): { html: string; tokens: string[] } {
  const tokens: string[] = [];
  let protectedHtml = html.replace(SCRIPT_BLOCK_RE, match => {
    const token = `__SANITIZE_SCRIPT_${tokens.length}__`;
    tokens.push(match);
    return token;
  });
  protectedHtml = protectedHtml.replace(SCRIPT_OPEN_RE, match => {
    const token = `__SANITIZE_SCRIPT_${tokens.length}__`;
    tokens.push(match);
    return token;
  });
  return { html: protectedHtml, tokens };
}

function restoreScriptBlocks(html: string, tokens: string[]): string {
  let result = html;
  tokens.forEach((original, index) => {
    result = result.replace(`__SANITIZE_SCRIPT_${index}__`, original);
  });
  return result;
}

/** innerHTML 주입 시 script 태그가 DOM 파싱을 끊지 않도록 표시용 이스케이프 */
function escapeScriptTagsForDisplay(html: string): string {
  return html.replace(/<\/?script\b[^>]*>/gi, tag => tag.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
}

function unwrapTableWrappers(root: Element): void {
  let changed = true;
  while (changed) {
    changed = false;
    const leafWrappers = Array.from(root.querySelectorAll('div[class*="tableWrapper"]')).filter(
      w => !w.querySelector('div[class*="tableWrapper"]'),
    );
    for (const wrapper of leafWrappers) {
      const parent = wrapper.parentNode;
      if (!parent) continue;

      Array.from(wrapper.querySelectorAll(':scope > br')).forEach(br => br.remove());
      while (wrapper.firstChild) {
        parent.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
      changed = true;
    }
  }
}

/** tableContainer 는 자식 전체를 올리고 컨테이너만 제거 (첫 table만 hoist 하면 형제 콘텐츠 유실) */
function unwrapTableContainers(root: Element): void {
  root.querySelectorAll('div[class*="tableContainer"]').forEach(container => {
    const parent = container.parentNode;
    if (!parent) return;
    while (container.firstChild) {
      parent.insertBefore(container.firstChild, container);
    }
    container.remove();
  });
}

function removeBrOutsideCells(root: Element): void {
  root.querySelectorAll('br').forEach(br => {
    if (!br.closest('td, th')) {
      br.remove();
    }
  });
}

/**
 * TinyMCE7 table 플러그인이 저장 시 삽입한 wrapper / 셀 밖 br 제거 (readonly 조회용)
 * - 레거시( table 플러그인 제외 ) 조회와 동일한 flat HTML 구조로 맞춤
 */
export function sanitizeReadonlyEditorHtml(html: string | null | undefined): string {
  if (html == null || html === '') return '';

  const source = String(html);
  const { html: protectedHtml, tokens } = protectScriptBlocks(source);

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${protectedHtml}</div>`, 'text/html');
  const root = doc.body.firstElementChild;
  if (!root) return escapeScriptTagsForDisplay(restoreScriptBlocks(source, tokens));

  unwrapTableWrappers(root);
  unwrapTableContainers(root);
  removeBrOutsideCells(root);

  return escapeScriptTagsForDisplay(restoreScriptBlocks(root.innerHTML, tokens));
}
